import { ShopAndSmileAPIAdapter } from '@bofrak-backend/shared';

export const BASE_URL = import.meta.env.VITE_BASE_URL ?? '';

export const apiAdapter = new ShopAndSmileAPIAdapter({
  apiEndpoint: BASE_URL,
});
